import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/provet'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'PROVET_SETTINGS.TITLE',
        icon: 'i-lucide-shield-plus',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'provet_settings',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};

